<script>
  import { fade } from 'svelte/transition';
  import { Breadcrumbs } from './Breadcrumbs';

  export let open = false;
</script>

<div class="breadcrumbs-container">
  <Breadcrumbs />
</div>
<div class="layout-container" class:open class:has-panel={$$slots.panel} in:fade={{ duration: 500 }} out:fade={{ duration: 500 }}>
  {#if $$slots.panel}
    <div class="layout-panel-container">
      <slot name="panel" />
    </div>
  {/if}
  <div class="layout-content-container"><slot name="content" /></div>
</div>

<style>
  .breadcrumbs-container {
    height: var(--layout-panel-height-mobile);
    position: fixed;
    display: flex;
    align-items: center;
    z-index: 2;
    padding-inline-start: var(--layout-side-padding);
  }

  .layout-container {
    height: var(--layout-height);
    width: var(--layout-width);
    display: flex;
    flex-direction: column;
  }

  .layout-panel-container {
    height: var(--layout-panel-height-mobile);
    display: flex;
    justify-content: space-between;
  }

  .layout-content-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    position: relative;
    background: var(--background);
    z-index: 0;
  }

  @media screen and (min-width: 1200px) {
    .layout-container.has-panel {
      flex-direction: row;
    }

    .layout-panel-container {
      order: 1;
      height: var(--layout-height);
      width: var(--layout-panel-width-desktop);
      transition: width var(--transition);
    }

    .layout-container.open .layout-panel-container {
      width: var(--layout-panel-width-desktop-open);
    }
  }
</style>
